<template>
    <div class="contractor_department">
        <MyTransition :myName="'up'">
            <Popup v-if="popupStatus">
                <PopupSuccess
                    v-if="popup == 'success'"
                    :text="successText"
                    @check="poupupEnter"
                ></PopupSuccess>
                <PopupError
                    v-if="popup == 'error'"
                    :text="successText"
                    @check="poupupEnter"
                ></PopupError>
            </Popup>
        </MyTransition>
        <button class="btn_primary return_Back" @click="returnBack">
            回上一頁
        </button>
        <div class="contain contain_white">
            <div class="form_input flex ">
                <label>需求單位</label>
                <div class="department_list">
                    <div
                        class="input_box flex"
                        v-for="(list, index) in department_list"
                        :key="index"
                    >
                        <Div> {{ index + 1 }} - {{ list.department }} </Div>
                        <div>
                            <button
                                @click="delDepartment(list, index)"
                                class="btn_error"
                            >
                                <i class="el-icon-delete"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form_input flex">
                <label>增加單位</label>
                <div class=" input_box flex">
                    <el-select v-model="department" placeholder="選擇部門">
                        <el-option
                            v-for="item in department_options"
                            :key="item.department_id"
                            :label="item.department"
                            :value="item.department_id"
                        >
                        </el-option>
                    </el-select>
                    <button @click="addDepartment" class="btn_primary">
                        增加
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss">
.return_Back {
    width: 100px;
    margin: 0px 0 10px 0;
}
.contractor_department {
    text-align: left;
    .department_list {
        flex: 7;
    }
    .form_input {
        align-items: center;
        font-size: 15px;
        margin: 15px 0;
        label {
            flex: 1.5;
            &.label_must_error {
                color: var(--subColor);
            }
        }
        .input_box {
            flex: 7;
            margin: 5px 0;
            justify-content: space-between;
            align-items: center;
        }
        .el_elment {
            width: 100%;
            .el-select {
                width: 100%;
            }

            .el-date-editor.el-input,
            .el-input {
                width: 100%;
                .el-input__prefix {
                    display: none;
                }
                input {
                    padding: 8px 10px;
                    border-radius: 5px;
                    background: #e5e5e5;
                    border: 1px solid #e5e5e5;
                    box-shadow: 1px 1px 2px -1px rgba(0, 0, 0, 0.2) inset;
                    &:hover,
                    &:focus {
                        background: #fff;
                        border: 1px solid #e5e5e5;
                        box-shadow: none;
                    }
                    /*webkit瀏覽器專用*/
                    &::-webkit-input-placeholder {
                        color: #b6b6b6;
                    }
                    /*Firefox 4-18瀏覽器專用*/
                    &::-moz-placeholder {
                        color: #b6b6b6;
                    }
                    /*IE10瀏覽器專用*/
                    &:-ms-input-placeholder {
                        color: #b6b6b6;
                    }
                }
            }
        }

        .btn_primary {
            margin: 0 10px;
            width: 120px;
        }
    }
}
</style>
<script>
export default {
    name: "department_manage",
    data() {
        return {
            department: null,
            department_options: [],
            department_list: this.$route.params.data.department,
            popupStatus: false,
            successText: null,
            popup: null
        };
    },
    methods: {
        getManage() {
            this.$http.api.admin.vendorList().then(res => {
                const data = res.data.filter(el => {
                    return el.vendor_id == this.$route.query.vendorId;
                });
                this.department_list = data[0].department;
            });
        },
        getDepartment() {
            this.$http.api.admin.department().then(res => {
                this.department_options = res.data;
            });
        },
        returnBack() {
            this.$router.go(-1);
        },
        delDepartment(list, index) {
            this.$http.api.admin
                .departmentManageDel({
                    data: {
                        department_id: list.department_id,
                        vendor_id: this.$route.query.vendorId
                    }
                })
                .then(res => {
                    this.popupStatus = true;
                    this.successText = "刪除成功";
                    this.popup = "success";
                    this.getManage();
                })
                .catch(error => {
                    this.popupStatus = true;
                    this.successText = "新增失敗";
                    this.popup = "error";
                });
        },
        addDepartment() {
            this.$http.api.admin
                .departmentManagePost({
                    department_id: this.department,
                    vendor_id: this.$route.query.vendorId
                })
                .then(res => {
                    this.popupStatus = true;
                    this.successText = "新增成功";
                    this.popup = "success";
                    this.getManage();
                })
                .catch(error => {
                    this.popupStatus = true;
                    this.successText = "新增失敗";
                    this.popup = "error";
                });
        },
        poupupEnter() {
            this.popupStatus = false;
        }
    },
    created() {
        this.getDepartment();
    }
};
</script>
